import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, " Forestående projekt er omfattet af affaldsbekendtgørelsens krav om screening, kortlægning og anmeldelse af byggeaffald (1), da projektet frembringer mere end 1 ton affald. ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Bygningsmassen er derfor undersøgt med henblik på at kortlægge, hvorvidt der er anvendt miljøproblematiske stoffer. Eksempelvis: ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "PCB"),
  /*#__PURE__*/_createElementVNode("li", null, "Klorparaffiner"),
  /*#__PURE__*/_createElementVNode("li", null, "Tungmetaller (bly, cadmium, krom, nikkel, kobber, zink og kviksølv)"),
  /*#__PURE__*/_createElementVNode("li", null, "Asbest"),
  /*#__PURE__*/_createElementVNode("li", null, "PAH"),
  /*#__PURE__*/_createElementVNode("li", null, "Kulbrinter")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " Der er ved undersøgelsen udtaget repræsentative prøver af bygningsmaterialer: Prøverne er udtaget som repræsentative stikprøver af materialer, hvor der erfaringsmæssigt og typisk forekommer miljøproblematiske stoffer. Der er lagt vægt på at identificere og udtage prøver af materialer, som er vurderet repræsentative for så stor en del af bygningsmassen som muligt, så resultatet er så retvisende som muligt. Der er ikke foretaget saneringsplaner. Mængdeopgørelse på de enkelte bygningsdele er vejledende estimater i nærværende rapport. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " Der er ved prøvetagningen udelukkende set på synlige og tilgængelige bygningsmaterialer, som potentielt kan indeholde miljøproblematiske stoffer. ", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Materialeprøver og analyseresultater fremgår under ")
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Prøveudtagningssteder fremgår under ")
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode(", hvor det er angivet på en vejledende plantegning samt med fotodokumentation under den enkelte registrering. ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Analyserapporten er vedlagt som bilag til nærværende miljø- og ressourcekortlægningsrapport. Under ")
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" og under den enkelte registrering fremgår det ved farvemarkering, hvilken affaldskategori den pågældende prøve og dermed det pågældende bygningsmateriale hører ind under. ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, " I forbindelse med nærværende rapport er ejendommen ikke undersøgt for eventuel jordforurening. ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "PDFReferenceList" }, [
  /*#__PURE__*/_createElementVNode("h3", { id: "aria-reference-header" }, "Referencer"),
  /*#__PURE__*/_createElementVNode("ol", { "aria-labelledby": "aria-reference-header" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" (1) "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.retsinformation.dk/eli/lta/2021/2512",
        target: "_blank"
      }, "Bekendtgørelse om affald")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PDFPage = _resolveComponent("PDFPage")!

  return (_openBlock(), _createBlock(_component_PDFPage, {
    class: "PDFParadigmInspection",
    contentClasses: 'PDFRichText',
    context: _ctx.context
  }, {
    sectionTitle: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.section) + ". " + _toDisplayString(_ctx.mixWB('INSPECTION_AND_SAMPLING')), 1)
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("p", null, " I forbindelse med den forestående " + _toDisplayString(_ctx.paradigmContent.projectTypeText) + " kan der være materialer i skjulte konstruktioner, som ikke er omfattet af denne rapport. Hvis der under nedrivningen fremkommer materialer med mistanke om indhold af miljøproblematiske stoffer, skal der foretages nødvendige sikkerhedsmæssige foranstaltninger og tages kontakt til miljørådgiver. ", 1),
      (_ctx.isBuildingContext)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("a", {
              href: _ctx.link('SamplesAndAssesments'),
              target: "_blank"
            }, "prøver og vurderinger", 8, _hoisted_8),
            _hoisted_9
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_10, [
            _createTextVNode(" Der er i forbindelse med nærværende undersøgelse i alt udtaget " + _toDisplayString(_ctx.samplesCount) + " materialeprøver til analyse. Materialeprøver og analyseresultater fremgår under ", 1),
            _createElementVNode("a", {
              href: _ctx.link('SamplesAndAssesments'),
              target: "_blank"
            }, "prøver og vurderinger", 8, _hoisted_11),
            _hoisted_12
          ])),
      _createElementVNode("p", null, [
        _hoisted_13,
        _createElementVNode("a", {
          href: _ctx.link('BuildingsAndFloorPlans'),
          target: "_blank"
        }, "bygninger og grundplaner", 8, _hoisted_14),
        _hoisted_15
      ]),
      _createElementVNode("p", null, [
        _hoisted_16,
        _createElementVNode("a", {
          href: _ctx.link('SamplesAndAssesments'),
          target: "_blank"
        }, "prøver og vurderinger", 8, _hoisted_17),
        _hoisted_18
      ]),
      _hoisted_19,
      _hoisted_20
    ]),
    _: 1
  }, 8, ["context"]))
}